import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {ScrollToService} from '@services/scroll-to.service';
import {EventsService} from '@services/events.service';
import {NotyMessagesEnum} from '@helpers/noty-messages.enum';

@Component({
    providers: [],
    selector: 'specialist-form',
    templateUrl: './specialist-form.component.html',
})
export class SpecialistFormComponent implements OnInit, AfterViewInit {
    public id: number;

    public specialist: SpecialistViewInterface;

    public viewUrl = '/specialist/view';

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private events: EventsService,
    ) {
    }

    ngOnInit() {
        const { specialist } = this.route.snapshot.data;

        if (specialist) {
            this.specialist = specialist;
            this.id = this.specialist.id;
        }
    }

    ngAfterViewInit(): void {
        const fragment = this.route.snapshot.fragment;

        if (fragment) {
            ScrollToService.toById(fragment);
        }
    }

    afterSave(id: number) {
        this.events.showNoty({
            type: 'success',
            content: NotyMessagesEnum.specialistUpdatedMessage,
        });
        this.router.navigate(
            [this.viewUrl, id]
        );
    }
}
